import {
  CompletedSoftCheckDataResult,
  Typenames,
} from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import { useEffect, useState } from 'react';

const useSoftCheckPollingEffect = (
  softCheckResult: CompletedSoftCheckDataResult | undefined,
  refetchCheck: () => void,
) => {
  const router = useRouter();
  const MAX_ATTEMPTS = 12;
  const POLL_INTERVAL = 5000;

  const [isChecking, setIsChecking] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval> | null = null;

    const clearPollingInterval = () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const checkAndRoute = () => {
      if (
        softCheckResult?.__typename ===
          Typenames.GetSoftCreditCheckExistenceSuccess &&
        softCheckResult?.softCreditCheckComplete
      ) {
        setIsChecking(false);
        clearPollingInterval();
        router.dismissAll();
        router.navigate({
          pathname: '/varo-line-of-credit/line-of-credit-entry-point',
        });
      }
    };

    if (isChecking) {
      if (attempts === 0) {
        refetchCheck();
        checkAndRoute();
        setAttempts((prev) => prev + 1);
      }
      if (attempts < MAX_ATTEMPTS) {
        intervalId = setInterval(() => {
          refetchCheck();
          setAttempts((prev) => prev + 1);
        }, POLL_INTERVAL);
      }
      if (attempts >= MAX_ATTEMPTS) {
        clearPollingInterval();
        setShowError(true);
      }
      checkAndRoute();
    }

    return () => {
      clearPollingInterval();
    };
  }, [isChecking, attempts, softCheckResult, refetchCheck, router]);

  return {
    isChecking,
    attempts,
    showError,
    setIsChecking,
    setAttempts,
    setShowError,
  };
};

export default useSoftCheckPollingEffect;
